<div class="patient">
  <div class="wrapper">
    <div *ngIf="showPopUp" class="print-history-popup">
      <div class="print-history-popup-body">
        <h2 class="popup-title">Please select a doctor to whom the patient will be assigned</h2>
        <button
          (click)="showPopUp = false"
          class="print-history-popup-close"
          aria-label="close popup"
        ></button>
      </div>
    </div>

    <!-- ========================== header (start) ========================== -->
    <header class="l-header">
      <div class="on-mobile header-logo">
        <img src="assets/icons/logo.svg" alt="Artisan Sonics" />
      </div>
      <div class="l-header-panel">
        <div style="display: flex; align-items: center">
          <h1 class="t-title-main">
            {{ pageTitle }}
          </h1>
          <div class="l-flex l-flex-c t-field t-field-pad" *ngIf="AWLlist" style="margin-left: 2em">
            <label> Status </label>

            <i class="t-sep"></i>

            <select
              class="t-field t-select"
              [(ngModel)]="AWLStatus"
              (change)="AWL(); startdate = null; enddate = null"
            >
              <option value="All">All</option>
              <option value="Waiting">Waiting</option>
              <option value="In Progress">In Progress</option>
              <option value="Completed">Completed</option>
            </select>
          </div>
        </div>
        @if (isReports) {
          <div
            style="
              width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: space-around;
              align-items: center;
            "
          >
            <!-- ======= HMO Report Summary (Start) ======= -->
            @if (examReportResults && examReportResults.length > 0) {
              <span>Gastroscopy: {{ examTypeReportCount("Gastroscopy") }}</span>
              <span>Colonoscopy: {{ examTypeReportCount("Colonoscopy") }}</span>
              <span>Sigmoidoscopy: {{ examTypeReportCount("Sigmoidoscopy") }}</span>
              <span>Number Of Exams: {{ examReportResults.length }}</span>
              <button
                (click)="exporXmlList()"
                class="header-menu-link icon-file"
                aria-label="Export to Excel"
                matTooltip="Export to Excel"
              ></button>
            }
            <!-- ======= HMO Report Summary (End) ======= -->
          </div>
        }
        <button
          class="search-btn search-btn--newPatient"
          *ngIf="AWLlist && loginService.barcodeScan && !swiping"
          style="margin-left: auto; width: 8em"
          (click)="swiping = true; getcard()"
        >
          Scan barcode
        </button>
        <input
          *ngIf="AWLlist && loginService.barcodeScan && swiping"
          #swipeField
          (keyup)="barscan($event)"
          [(ngModel)]="card"
        />
        <nav class="on-mobile header-mobilePanel">
          <button
            class="btn-mobileMenu"
            id="open-mainNav"
            data-show=".l-sidebar"
            aria-label="open mobile sidebar"
          ></button>
        </nav>
        <!-- ======= Select Doctor Filter (Start) ======= -->
        <div
          *ngIf="
            (loginService.isAdmin || loginService.userType == 'secretary') &&
            (loginService.separatedClinic || loginService.SeparateZimun) && !isReports
          "
          style="position: absolute; right: 6em"
        >
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label matTooltip="שם הרופא">
              <img src="../../assets/icons/drb.svg" />
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              <select
                [(ngModel)]="loginService.doctor"
                (ngModelChange)="AWL()"
                class="t-select w100"
                style="text-align: center"
              >
                <option [value]="null">All</option>
                <!-- <option *ngIf="awlExam && ! examTypes.includes(awlExam)" [value]="awlExam">{{awlExam}}</option> -->
                <ng-container *ngFor="let e of getDoctors()">
                  <option [value]="e.UID">{{ e.Name }}</option>
                </ng-container>
              </select>
            </span>
          </div>
        </div>
        <!-- ======= Select Doctor Filter (End) ======= -->

          <img *ngIf="examList && examList.length && this.loginService.isAdmin" class="clickable"
            style="cursor: pointer; position: absolute; right: 3%; top: 55%; transform: translateY(-50%);"
            matTooltip="Download Report" (click)="generateXlExams(examList)" height="31em" src="../../assets/icons/file.svg" />
      </div>
    </header>
    <!-- ========================== header (end) ========================== -->

    <!-- ========================== intro (start) ========================== -->

    <main class="l-deashboard">
      <!-- =============== AWL (ToadyList) (End) =============== -->
      @if (awlListLoading) {
      <div class="list-spinner-wrap" [class.is-leaving]="awlListFading">
        <img src="../../assets/images/Wedges.svg" alt="Loading..." class="list-spinner-img" />
      </div>
      } @else {
        <!-- Only when the today list is loaded and empty; AWLlist is null during a patient search, so this stays hidden and disappears the instant a search starts -->
        @if (isAWL && AWLlist && AWLlist.length === 0) {
          @if (AWLStatus && AWLStatus != 'All') {
            <p class="empty-state">
              {{ 'GUI.Patients.empty.today status' | translate:{ status: ('GUI.Patients.todaylist.statues.' + AWLStatus | translate) } }}
            </p>
          } @else {
            <p class="empty-state">{{ 'GUI.Patients.empty.today' | translate }}</p>
          }
        }
        <div class="l-flex patient-item" *ngFor="let pat of AWLlist; index as i">
          <div class="w100 patient-item-link">
            <div class="l-table h100">
              <span
                class="l-td-m patient-item-cell patient-id"
                (click)="setAWL(pat); selectedPatient = pat"
              >
                Time:
                <strong>
                  {{ pat.ExamDate | date : "shortTime" }}
                </strong>
              </span>
              <span
                class="l-td-m patient-item-cell patient-id"
                (click)="setAWL(pat); selectedPatient = pat"
              >
                ID: <strong>{{ pat.ID }}</strong>
              </span>
              <span
                class="l-td-m patient-item-cell patient-name-first"
                [ngClass]="pat.Reason ? 'type-v' : 'type-plus'"
                (click)="setAWL(pat); selectedPatient = pat"
              >
                {{ pat.First }} {{ pat.Last }}
                <img src="../../assets/icons/patlabel.svg" style="float: inline-end;" matTooltip="Print Label" (click)="$event.stopPropagation();printLabel(pat.HMO, pat.PID)" />
              </span>

              <span
                class="l-td-m patient-item-cell patient-name-last"
                *ngIf="loginService.ishospital && !loginService.AWLExamNames"
                (click)="setAWL(pat); selectedPatient = pat"
              >
                Address: {{ pat.Address }} {{ pat.City }}
              </span>
              <span
                class="l-td-m patient-item-cell patient-name-first"
                *ngIf="!loginService.ishospital"
                (click)="setAWL(pat); selectedPatient = pat"
              >
                Phone: {{ pat.Phone ? pat.Phone : pat.Mobile }}
              </span>
              <span
                class="l-td-m patient-item-cell patient-name-first"
                *ngIf="(!loginService.ishospital || loginService.AWLExamNames) && pat.ExamCode"
              >
                {{ pat.ExamCode }}
                <span style="position: relative; display: inline-block;">
                  <img
                    *ngIf="loginService.premissions && loginService.premissions['Questionnaires']"
                    src="../../assets/icons/chat.svg"
                    style="float: inline-end; cursor: pointer;"
                    matTooltip="Send Questionnaire"
                    (click)="$event.stopPropagation(); openSendQuestionnaire(pat)"
                  />
                  <span *ngIf="patQuestionnaireAnswered[pat.AWLID]" style="position: absolute; bottom: -0.1em; right: -0.4em; font-size: 0.75em; color: green; font-weight: bold; background: white; border-radius: 50%; line-height: 1; padding: 0 1px;">✓</span>
                </span>
              </span>
              <span
                class="l-td-m patient-item-cell patient-name-first"
                *ngIf="
                  loginService.separatedClinic &&
                  (loginService.isAdmin || loginService.userType == 'secretary')
                "
              >
                {{ loginService.getDocByUID(pat.UID) }}
              </span>

              <span
                class="l-td-m patient-item-cell patient-name-first"
                (click)="setAWL(pat); selectedPatient = pat"
              >
                {{ getStatus(pat.Status) }}
              </span>
            </div>
          </div>
          <a
            class="l-td-m patient-item-exit"
            routerLink="/exams"
            (click)="patservice.setPat(pat); setPatAwlid(pat)"
            [state]="{ data: pat }"
          ></a>
        </div>
      }
      <!-- =============== AWL (ToadyList) (End) =============== -->

      <!-- =============== Search Patients (Start) =============== -->
      <!-- Pagination + result count, shown above and below the list -->
      @if (!patListLoading && patList && patList.length > 0) {
      <app-pagination-controls
        [total]="totalResults"
        [page]="currentPage"
        [totalPages]="totalPages"
        (prev)="previousPage()"
        (next)="nextPage()"
      ></app-pagination-controls>
      }
      @if (patListLoading) {
      <div class="list-spinner-wrap" [class.is-leaving]="patListFading">
        <img src="../../assets/images/Wedges.svg" alt="Loading..." class="list-spinner-img" />
      </div>
      } @else {
        <!-- patList is null until a search runs, so only an empty array means "no matches" -->
        @if (patList && patList.length === 0) {
          <p class="empty-state">{{ 'GUI.Patients.empty.patients' | translate }}</p>
        }
        <div class="l-flex patient-item" *ngFor="let pat of patList">
        <button
          class="w100 patient-item-link"
          (click)="selectedPatient = pat"
          matTooltip="Open Patient Record"
        >
          <div class="l-table h100">
            <span class="l-td-m patient-item-cell patient-id">
              {{ pat.IsID ? "ID" : "Passport" }}: <strong>{{ pat.ID }}</strong>
            </span>

            <span class="l-td-m patient-item-cell patient-name-first">
              {{ pat.First }}
            </span>

            <span class="l-td-m patient-item-cell patient-name-last">
              {{ pat.Last }}
            </span>
            <span
              class="l-td-m patient-item-cell patient-name-first"
              *ngIf="
                loginService.separatedClinic &&
                (loginService.isAdmin || loginService.userType == 'secretary')
              "
            >
              {{ loginService.getDocByUID(pat.UID) }}
            </span>
          </div>
        </button>
        <a
          class="l-td-m patient-item-exit"
          routerLink="/exams"
          (click)="patservice.setPat(pat)"
          [state]="{ data: pat }"
          matTooltip="Open Patient History"
        ></a>
      </div>
      }
      @if (!patListLoading && patList && patList.length >= pageSize && totalPages > 1) {
      <app-pagination-controls
        [total]="totalResults"
        [page]="currentPage"
        [totalPages]="totalPages"
        (prev)="previousPage()"
        (next)="nextPage()"
      ></app-pagination-controls>
      }
      <!-- =============== Search Patients (End) =============== -->

      <!-- =============== Search Exams (Start) =============== -->
      @if (examListLoading) {
      <div class="list-spinner-wrap" [class.is-leaving]="examListFading">
        <img src="../../assets/images/Wedges.svg" alt="Loading..." class="list-spinner-img" />
      </div>
      } @else if (examList) {
        @if (examList.length === 0) {
          <p class="empty-state">{{ 'GUI.Patients.empty.exams' | translate }}</p>
        }
        <!-- ======= Exam Search Parameters Info (Start) ======= -->
        <div *ngIf="isReports && exServ.searchReport"
          style="margin: 10px; padding: 10px; border-radius: 10px; border: 1px solid grey;">
          <div style="display: flex; justify-content: space-evenly; flex-wrap: wrap; gap: 0.5rem;">
            <span *ngIf="exServ.searchReport.hmo"><strong>HMO:</strong> {{ getHMO(exServ.searchReport.hmo) }}</span>
            <span *ngIf="exServ.searchReport.type"><strong>Report:</strong> {{ getType(exServ.searchReport.type) }}</span>
            <span style="display: flex; flex-direction: row; gap: 0.25rem;">
              <strong>Dates:</strong>
              <span>{{ exServ.searchReport.start | date: 'dd/MM/yyyy' }}</span>
              <label>-</label>
              <span>{{ exServ.searchReport.end | date: 'dd/MM/yyyy' }}</span>
            </span>
          </div>
        </div>
        <!-- ======= Exam Search Parameters Info (End) ======= -->

        <!-- ======= Exam Groups (Start) ======= -->
        <div *ngFor="let name of examNames" style="margin: 1em 0;">
          <div *ngIf="filterExams(examList, name).length > 0"
            class="l-flex" style="display: flex; justify-content: space-between;">
            <span style="font-size: x-large;"><strong>{{ name }}</strong></span>
            <div class="l-flex r-hmos">
              <span
                *ngIf="loginService.limits && loginService.limits[getDbName(name, 'Leumit')]"
                [ngClass]="(examList && filterExams(examList, name, 'Leumit').length >= loginService.limits[getDbName(name, 'Leumit')]) ? 'error' : ''"
                style="font-size: x-large;">
                <strong>Leumit: {{ filterExams(examList, name, 'Leumit').length }}/{{ loginService.limits[getDbName(name, 'Leumit')] }}</strong>
              </span>
              <span
                *ngIf="loginService.limits && loginService.limits[getDbName(name, 'Macabi')]"
                [ngClass]="(examList && filterExams(examList, name, 'Macabi').length >= loginService.limits[getDbName(name, 'Macabi')]) ? 'error' : ''"
                style="font-size: x-large;">
                <strong>Macabi: {{ filterExams(examList, name, 'Macabi').length }}/{{ loginService.limits[getDbName(name, 'Macabi')] }}</strong>
              </span>
              <span
                *ngIf="loginService.limits && loginService.limits[getDbName(name, 'Meuhedet')]"
                [ngClass]="(examList && filterExams(examList, name, 'Meuhedet').length >= loginService.limits[getDbName(name, 'Meuhedet')]) ? 'error' : ''"
                style="font-size: x-large;">
                <strong>Meuhedet: {{ filterExams(examList, name, 'Meuhedet').length }}/{{ loginService.limits[getDbName(name, 'Meuhedet')] }}</strong>
              </span>
              <span
                *ngIf="loginService.limits && loginService.limits[getDbName(name, 'Clalit')]"
                [ngClass]="(examList && filterExams(examList, name, 'Clalit').length >= loginService.limits[getDbName(name, 'Clalit')]) ? 'error' : ''"
                style="font-size: x-large;">
                <strong>Clalit: {{ filterExams(examList, name, 'Clalit').length }}/{{ loginService.limits[getDbName(name, 'Clalit')] }}</strong>
              </span>
            </div>
          </div>
          @for (exam of filterExams(examList, name); track exam) {
          <div class="l-flex patient-item">
            <button
              class="w100 patient-item-link"
              (click)="goPatient(exam.PID)"
              matTooltip="Click to View Patient History"
            >
              <div class="l-table h100">
                <span class="l-td-m patient-item-cell patient-name-first">
                  Exam Time: <strong>{{ exam.CreationTime | date: "dd/MM/yyyy h:mm a" }}</strong>
                </span>
                <span class="l-td-m patient-item-cell patient-id">
                  ID: <strong>{{ exam.ID }}</strong>
                </span>
                <span class="l-td-m patient-item-cell patient-id">
                  Name: {{ exam.First }} {{ exam.Last }}
                </span>
                <span class="l-td-m patient-item-cell patient-name-first">
                  Exam Type:
                  <strong>{{ exam.ExamType }}
                    <span *ngIf="exam.Changed">({{ exam.ChangedExamTitle }})</span>
                  </strong>
                </span>
              </div>
            </button>
            <a
              class="l-td-m patient-item-exit"
              [ngClass]="getLocked(exam)"
              (click)="goExam(exam)"
              [matTooltip]="getLocked(exam) === 'locked' ? 'Locked By: ' + exam.LockedBy : 'View Exam'"
            ></a>
          </div>
          }
        </div>
        <!-- ======= Exam Groups (End) ======= -->
      }
      <!-- =============== Search Exams (End) =============== -->

      <!-- =============== Reports Search Results (Start) =============== -->
      <!-- ======= Reports Search Parameters Info (Start) ======= -->
      @if (isReports && exServ.searchReport) {
        <div style="margin-bottom: 1.5em; padding: 10px; border-radius: 10px; border: 1px solid grey;">
          <div style="display: flex; justify-content: space-evenly; flex-wrap: wrap; gap: 0.5rem;">
            <span class="l-flex l-flex-c" style="gap: 0.35rem;">
              <strong>HMO:</strong>
              <select
                class="t-field t-select"
                [ngModel]="reportSearchHmo"
                (ngModelChange)="changeReportHmo($event)"
              >
                <option value="All">All HMOs</option>
                <option value="Clalit">Clalit</option>
                <option value="Meuhedet">Meuhedet</option>
                <option value="Leumit">Leumit</option>
                <option value="Macabi">Macabi</option>
                <option value="Others">Private / IDF / unassigned</option>
              </select>
            </span>
            <span><strong>Exam Type:</strong> {{ reportSearchExamType }}</span>
            <span>
              <strong>Dates:</strong>
              {{ exServ.searchReport.start | date: 'dd/MM/yyyy' }} &ndash;
              {{ exServ.searchReport.end | date: 'dd/MM/yyyy' }}
            </span>
          </div>
          <!-- ======= Failure Case Filters (Start) ======= -->
          <!-- A status search only, and one case at a time. Every case is
               already loaded, so switching between them costs no search. Until
               one is picked the list stays empty and the counts alone say where
               the work is. Each count is out of every exam of the searched
               scope, problem-free ones included. -->
          @if (reportStatusMode && reportFailCounts) {
            <div class="report-fails">
              <label class="report-fails-item">
                <input
                  type="radio"
                  name="reportFailCase"
                  class="custom-check customInput"
                  [checked]="reportFailCase === 'noPrn'"
                  (change)="selectReportFail('noPrn')"
                />
                <i class="customInput-display"></i>
                <span>No PRN</span>
                <strong class="report-fails-count">{{ reportFailCounts.noPrn }}/{{ reportFailCounts.total }}</strong>
              </label>
              <label class="report-fails-item">
                <input
                  type="radio"
                  name="reportFailCase"
                  class="custom-check customInput"
                  [checked]="reportFailCase === 'notSigned'"
                  (change)="selectReportFail('notSigned')"
                />
                <i class="customInput-display"></i>
                <span>Not Signed</span>
                <strong class="report-fails-count">{{ reportFailCounts.notSigned }}/{{ reportFailCounts.total }}</strong>
              </label>
              <label class="report-fails-item">
                <input
                  type="radio"
                  name="reportFailCase"
                  class="custom-check customInput"
                  [checked]="reportFailCase === 'notSent'"
                  (change)="selectReportFail('notSent')"
                />
                <i class="customInput-display"></i>
                <span>Not Sent</span>
                <strong class="report-fails-count">{{ reportFailCounts.notSent }}/{{ reportFailCounts.total }}</strong>
              </label>
            </div>
          }
          <!-- ======= Failure Case Filters (End) ======= -->
        </div>
      }
      <!-- ======= Reports Search Parameters Info (End) ======= -->
      @if (examReportLoading) {
        <div class="list-spinner-wrap" [class.is-leaving]="examReportFading">
          <img src="../../assets/images/Wedges.svg" alt="Loading..." class="list-spinner-img" />
        </div>
      } @else if (isReports && examReportResults !== null) {
        @if (examReportResults.length === 0) {
          @if (reportStatusMode && !reportFailCase) {
            <p class="empty-state" style="padding: 2rem; text-align: center;">Pick No PRN, Not Signed or Not Sent above to list those exams.</p>
          } @else if (reportFailCase) {
            <p class="empty-state" style="padding: 2rem; text-align: center;">No exams are {{ reportSearchStatusLabel }} out of the {{ reportFailCounts?.total || 0 }} found for {{ reportSearchHmoLabel }} in this period.</p>
          } @else {
            <p class="empty-state" style="padding: 2rem; text-align: center;">No exams found for {{ reportSearchHmoLabel }} in this period.</p>
          }
        } @else {
          @for (name of examNamesGastro; track name) {
            @if (filterExams(examReportResults, name).length > 0) {
              <!-- ======= Exam Type Group (Start) ======= -->
              <div style="margin: 1em 0;">
                <div class="l-flex" style="display: flex; justify-content: space-between;">
                  <span style="font-size: x-large; margin-bottom: 0.5em;"><strong>{{ name }}</strong></span>
                </div>
                @for (exam of filterExams(examReportResults, name); track exam.AutoIndex) {
                  <div class="l-flex patient-item"
                    [ngClass]="'exam-send-status-row exam-send-status-row--' + examReportsStatusLabel(exam)">
                    <button
                      class="w100 patient-item-link"
                      (click)="goPatient(exam.PID)"
                      matTooltip="Click to View Patient History"
                    >
                      <div class="l-table h100">
                        <span class="l-td-m patient-item-cell patient-name-first">
                          {{ exam.First }} {{ exam.Last }}
                        </span>
                        <span class="l-td-m patient-item-cell patient-id" style="width: 7.5em !important;">
                          ID: <strong>{{ exam.PatientID }}</strong>
                        </span>
                        <span class="l-td-m patient-item-cell patient-name-first">
                          Created: <strong>{{ exam.CreationTime | date: 'dd/MM/yyyy HH:mm' }}</strong>
                        </span>
                        <span class="l-td-m patient-item-cell patient-name-first">
                          Signed:
                          <strong *ngIf="exam.SignedDate">{{ exam.SignedDate | date: 'dd/MM/yyyy HH:mm' }}</strong>
                          <strong *ngIf="!exam.SignedDate">Not signed</strong>
                        </span>
                        <span class="l-td-m patient-item-cell patient-name-first">
                          HMO: <strong>{{ exam.HMO || '—' }}</strong>
                        </span>
                        <span class="l-td-m patient-item-cell patient-name-first"  style="width: 7em !important;">
                          PRN: <strong>{{ exam.PRN || '—' }}</strong>
                        </span>
                        <span class="l-td-m patient-item-cell patient-name-first" style="width: 7em !important;">
                          PRN2: <strong>{{ exam.PRN2 || '—' }}</strong>
                        </span>
                        <span class="l-td-m patient-item-cell patient-name-first">
                          Status: <strong>{{ examReportsStatusText(exam) }}</strong>
                        </span>
                      </div>
                    </button>
                    <a
                      class="l-td-m patient-item-exit"
                      (click)="goExam(exam)"
                      matTooltip="View Exam"
                    ></a>
                  </div>
                }
              </div>
              <!-- ======= Exam Type Group (End) ======= -->
            }
          }
        }
      }
      <!-- =============== Reports Search Results (End) =============== -->
    </main>

    <!-- ========================== main sidebar (start) ========================== -->

    <aside class="l-sidebar l-flex l-column">
      <img class="off-mobile sidebar-logo" src="assets/icons/logo.svg" alt="Artisan Sonics" />

      <!-- user panel (start) -->
      <div class="userPanel">
        <i class="userPanel-icon icon-female"> </i>

        <div class="userPanel-userName">Patient Search</div>

        <div class="search-patient">
          <div class="search-patient-field">
            <div class="t-field l-flex t-twin-fieldset">
              <label>
                <input
                  type="radio"
                  name="idp"
                  [(ngModel)]="idp"
                  [value]="1"
                  class="custom-check customInput"
                  aria-labelledby="pregnancy_popup-sex"
                />
                <i class="customInput-display"></i>
                <span class="t-field-desc"> ID </span>
              </label>
              <label>
                <input
                  type="radio"
                  name="idp"
                  [value]="0"
                  class="custom-check customInput"
                  aria-labelledby="pregnancy_popup-sex"
                />
                <i class="customInput-display"></i>
                <span class="t-field-desc"> Passport </span>
              </label>
            </div>
          </div>

          <div class="t-validation-wrap">
            <input
              type="text"
              class="search-patient-field idnumber"
              [ngClass]="invalidi"
              placeholder="ID Number"
              [(ngModel)]="id"
              (keyup)="invalidi = ''; trysearch()"
              pattern="[A-Za-z0–9\-]+"
            />
            <div class="t-validation-message">
              <span>Invalid ID Number</span>
            </div>
          </div>

          <div class="t-validation-wrap">
            <input
              type="text"
              class="search-patient-field"
              placeholder="First Name"
              [ngClass]="invalidf"
              [(ngModel)]="first"
              (keyup)="invalidf = ''; trysearch()"
            />
            <div class="t-validation-message">
              <span>Please fill in first name</span>
            </div>
          </div>

          <div class="t-validation-wrap">
            <input
              type="text"
              class="search-patient-field"
              placeholder="Last Name"
              [ngClass]="invalidl"
              [(ngModel)]="last"
              (keyup)="invalidl = ''; trysearch()"
            />
            <div class="t-validation-message">
              <span>Please fill in last name</span>
            </div>
          </div>

          <div class="t-validation-wrap">
            <input type="tel" inputmode="tel" class="search-patient-field" placeholder="Phone" [(ngModel)]="phone" (keyup)="trysearch()" />
            <div class="t-validation-message">
              <span>Invalid phone</span>
            </div>
          </div>

          <div class="l-flex l-flex-w t-fieldmargin search-btns">
            <div class="w100" *ngIf="loginService.showAWL()">
              <button
                class="search-btn"
                (click)="AWL(); isReports = false"
                matTooltip="Artisan Worklist"
                matTooltipPosition="after"
              >
                TodayList
              </button>
            </div>
            <div class="w50">
              <button
                class="search-btn"
                [disabled]="isSearchButtonDisabled"
                (click)="search(true); isReports = false"
                matTooltip="Search Patient"
                matTooltipPosition="after"
              >
                Search
              </button>
            </div>
            <div class="w50">
              <button
                class="search-btn"
                (click)="clear()"
                [ngClass]="
                  id.length > 0 || last.length > 0 || first.length > 0 || phone.length > 0
                    ? ''
                    : 'search-btn--clear'
                "
                matTooltip="Clear Search Fields"
                matTooltipPosition="after"
              >
                Clear
              </button>
            </div>
            <div class="w100">
              <button
                class="search-btn search-btn--newPatient"
                (click)="addPatient(); isReports = false"
                matTooltip="Open New Patient"
                matTooltipPosition="after"
              >
                New Patient
              </button>
            </div>
            <div class="w100">
              <button
                class="search-btn"
                matTooltip="Search Exams"
                (click)="openEsearch = true; isReports = false"
                matTooltipPosition="after"
              >
                Search Exams
              </button>
            </div>
            <div class="w100">
              <button
                class="search-btn"
                matTooltip="Reports"
                *ngIf="loginService.userType == 'secretary'"
                (click)="openEsearch = true; isReports = true"
                matTooltipPosition="after"
              >
                Reports
              </button>
            </div>
            <div class="w100" *ngIf="loginService.premissions && loginService.premissions['GastroLabReports']">
              <button
                class="search-btn"
                matTooltip="{{'GUI.gastro.lab_results.tooltips.Go to lab results' | translate}}"
                [routerLink]="['/labresults']"
                [queryParams]="unassignedLabReports > 0 ? { unassignedLabReports: unassignedLabReports } : {}"
                matTooltipPosition="after"
              >
                {{'GUI.gastro.lab_results.title.lab_results' | translate}}
                <div
                [matBadge]="unreadLabReports"
                [matBadgeHidden]="unreadLabReports === 0"
                matBadgeColor="warn"
                matBadgePosition="above after"
                aria-label="New Lab Results">
            </div>
              </button>
            </div>
          </div>
        </div>

        <div class="search-help">
          Need help?
          <button class="open-help" (click)="openHelp()">Click Here</button>
        </div>
      </div>
      <!-- user panel (end) -->

      <!-- main nav (start) -->
      <nav class="mainNav l-fg1 scroller"></nav>
      <!-- main nav (end) -->
      <app-docpanel></app-docpanel>
    </aside>

    <!-- ========================== main sidebar (end) ========================== -->

    <app-bottombar></app-bottombar>
  </div>
  <!-- end wrapper -->

  <!-- ===================================== POPUP : HELP (START) =============================================== -->

  <div class="t-popup popup-help" *ngIf="showhelp">
    <div class="t-popup-close"></div>

    <div class="t-popup-frame">
      <div class="t-popup-body">
        <button class="t-btn-popup-close" aria-label="close popup" (click)="showhelp = false"></button>

        <h2>Help</h2>

        <section class="part-help">
          <h3>Search</h3>

          It is a long established fact that a reader will be distracted by the readable content of a
          page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less
          normal distribution of letters, as opposed to using 'Content here, content here', making it
          look like readable English. Many desktop publishing packages and web page editors now use Lorem
          Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites
          still in their infancy. Various versions have evolved over the years, sometimes by accident,
          sometimes on purpose (injected humour and the like).
        </section>
      </div>
    </div>
  </div>
  <div class="t-popup popup-help" *ngIf="carderror" style="display: inherit">
    <div class="t-popup-close"></div>

    <div class="t-popup-frame">
      <div class="t-popup-body">
        <button class="t-btn-popup-close" aria-label="close popup" (click)="carderror = null"></button>

        <h2 style="direction: rtl; margin-right: 3em">
          מטופל עם ת.ז. {{ carderror }} לא נמצאה ברשימת המוזמנים להיום.
        </h2>

        <section class="part-help">
          <h3 style="direction: rtl">נא לבדוק נכונות המספר ולנסות שוב</h3>
        </section>
      </div>
    </div>
  </div>

  <!-- <div class="t-popup popup-help" *ngIf="tocopy" style="display: inherit">
    
            <div class="t-popup-close"></div>
            
            <div class="t-popup-frame">
                <div class="t-popup-body">
    
                    <button class="t-btn-popup-close" aria-label="close popup" (click)="toreassign=null;AWL()"></button>
    
                    <h2>
                        Warning!
                    </h2>
    
                    <section class="part-help">
    
                        <h3>
                            This will remove {{toreassign.First + ' ' + toreassign.Last}} from {{loginService.getDocByUID(toreassign.UID)}} and make her a patient of {{loginService.getDocByUID(toreassign.nUID)}}.
                        </h3>
                        <button (click)="reassign()">OK</button>    
                        <button style="float:right" (click)="toreassign=null;AWL()">Cancel</button> 
                    </section>                 
                </div>
            </div>
        </div>--->

  <app-informconcent
    *ngIf="inform"
    (closed)="closCalForm($event)"
    [pat]="exServ.patServ.getPat()"
    [form]="concentForm"
  ></app-informconcent>

  <app-loginbox
    *ngIf="showLogin"
    (closed)="showLogin = false"
    (viewonly)="viewonly()"
    [search]="true"
    [isnew]="false"
  ></app-loginbox>
  <app-patdetails
    *ngIf="selectedPatient && !typeForm"
    [pat]="selectedPatient"
    [awl]="chosenAWL"
    [awlExam]="awlExamType"
    [awlTime]="awlTime"
    [awlLMP]="awlLMP"
    [awlComment]="awlComment"
    [openWAWL]="loginService.barcodeScan"
    (closed)="onClosed($event)"
    (showpay)="paymentNoCard()"
  ></app-patdetails>
  <app-payment
    *ngIf="showpayment"
    [tz]="showpayment"
    [idtype]="idcode"
    [awlid]="selectedPatient.AWLID"
    [exp]="expcode"
    (closed)="showpayment = null"
  ></app-payment>
  <app-searchbox
    *ngIf="openEsearch"
    (closed)="searchClosed($event)"
    (closeReports)="searchHmoReport($event)"
    [isReports]="isReports"
    [lastreport]="loginService.lastReportSearch"
    [hmostype]="hmostype"
    [isGastro]="loginService.isGastro"
    [startdate]="fromd"
    [enddate]="tod"
    [examtype]="examMode"
    [exams]="examVals"
  ></app-searchbox>
  <app-commerror></app-commerror>
  <app-printopts
    *ngIf="showprint"
    (closed)="showprint = false"
    [showopts]="showprintopts"
    [stats]="true"
    [isReport]="true"
    [type]="reportName"
    [startdate]="fromd"
    [enddate]="tod"
    [hmostype]="hmostype"
  >
  </app-printopts>
  <app-send-questionnaire
    *ngIf="showSendQuestionnaire"
    [patient]="sendQuestionnairePatient"
    (closed)="showSendQuestionnaire = false; selectedPatient = null"
  ></app-send-questionnaire>
</div>
